import { render, staticRenderFns } from "./AppDropdown.vue?vue&type=template&id=10c8958a&scoped=true&"
import script from "./AppDropdown.vue?vue&type=script&lang=js&"
export * from "./AppDropdown.vue?vue&type=script&lang=js&"
import style0 from "./AppDropdown.vue?vue&type=style&index=0&id=10c8958a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c8958a",
  null
  
)

export default component.exports